<template>
  <with-loader id="exampleDetail"
               class="flex flex-col bg-white border-0 border-l border-solid border-soft px-6 py-8"
               :loading="loading"
               use-as-overlay
               v-bar
  >
    <div class="flex flex-col">
      <answers-report-example-detail-top :reason-labels="reasonLabels"
                                         :reason-icons="reasonIcons"
                                         :bot-id="botId"
      />
      <answers-report-example-detail-bottom class="h-full mt-16" :bot-id="botId"/>
    </div>
  </with-loader>
</template>

<script>
import AnswersReportExampleDetailTop from '@/components/answers/report/AnswersReportExampleDetailTop'
import AnswersReportExampleDetailBottom from '@/components/answers/report/AnswersReportExampleDetailBottom'
import WithLoader from '@/components/common/WithLoader'

export default {
  name: 'AnswersReportExamplesDetail',

  components: { WithLoader, AnswersReportExampleDetailTop, AnswersReportExampleDetailBottom },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    reasonIcons: {
      type: Object,
      default: () => {}
    },
    reasonLabels: {
      type: Object,
      default: () => {}
    },
    botId: {
      type: String,
      default: ''
    }
  }
}
</script>
